import { defineComponent as _defineComponent } from 'vue'
import {
  ButtonPrimary,
  ButtonContainer,
  Modal,
  HelperViewContextual,
} from '@warrenbrasil/nebraska-web';
import { Portal } from '@/modules/common/components/Portal';
import { getDomainAndPlatform } from '@/modules/common/helpers/onboarding/getDomainAndPlatform';


export default /*#__PURE__*/_defineComponent({
  __name: 'ContinueRegistrationModal',
  props: {
    isOpen: { type: Boolean }
  },
  emits: ['close'],
  setup(__props: any, { emit }) {





function handleClose() {
  emit('close');
}

function handleContinue() {
  const { domain, platform } = getDomainAndPlatform();
  window.location.href = `/onboarding/${domain}/${platform}/states/register-personal`;
}

return { __sfc: true,emit, handleClose, handleContinue, ButtonPrimary, ButtonContainer, Modal, HelperViewContextual, Portal }
}

})